export default [
    {
        path: '/feedbacks/',
        component: () => import('../components/FeedbackList.vue'),
        name: 'feedbacks',
        meta: {},
    },

]